export default {
  path: '/wecode/docold',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'docold',
  component: () => import('./index')
};
